import { render, staticRenderFns } from "./CalculationTax.vue?vue&type=template&id=3531f6ba&"
import script from "./CalculationTax.vue?vue&type=script&lang=js&"
export * from "./CalculationTax.vue?vue&type=script&lang=js&"
import style0 from "./CalculationTax.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports